import { render, staticRenderFns } from "./ClassReview.vue?vue&type=template&id=0d2bf316"
import script from "./ClassReview.vue?vue&type=script&lang=js"
export * from "./ClassReview.vue?vue&type=script&lang=js"
import style0 from "./ClassReview.vue?vue&type=style&index=0&id=0d2bf316&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports